import React, { useEffect, useState } from "react";

import axios from "axios";
import useAuthorization from "../../hooks/useAuthorization";
import { Table } from "react-bootstrap";
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import { createAxiosInstance } from "../../utils/axios-instance";
import { useMsal } from "@azure/msal-react";
dayjs.extend(utc)

const XperHistory = ({ request }) => {
  const { instance } = useMsal();
  const [items, setItems] = useState([]);

  useEffect(() => {
    const axiosInstance = createAxiosInstance(instance);
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_ENDPOINT}compliance/request/xferhistory/${request.requestToken}`
      )
      .then((resp) => {
        setItems(resp.data);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [request]);

  return (
    <Table striped bordered>
      <thead>
        <tr>
          <th>Date of XFER</th>
          <th>FROM</th>
          <th>TO</th>
        </tr>
      </thead>
      <tbody>
        {items.map((item) => (
          <tr key={item.createdDate}>
            <td>{dayjs(item.createdDate).format("MM/DD/YYYY hh:mm A")}</td>
            <td>{`${item.prevFirstName} ${item.prevLastName} ${item.prevEmail}`}</td>
            <td>{`${item.currentFirstName} ${item.currentLastName} ${item.currentEmail}`}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default XperHistory;
